export const uk = {
  title: "Редактор ПІІ в браузері",
  tagline: "Жоден текст не покидає ваш пристрій. Частина сутностей визначається тільки після запуску моделі.",
  skip: "Перейти до тексту",
  navRedactor: "Редактор",
  navMetrics: "Метрики",
  lang: "Мова",
  langUk: "UA",
  langEn: "EN",
  theme: "Тема",
  themeLight: "Світла",
  themeDark: "Темна",
  themeSystem: "Системна",
  inputLabel: "Текст для перевірки",
  inputPlaceholder: "Вставте лист, чат або витяг. Синтетичні приклади — кнопки нижче.",
  samples: "Приклади",
  sampleSupport: "Чат підтримки",
  sampleBank: "Платіж",
  sampleKyc: "KYC-форма",
  sampleMixed: "UA / RU / EN",
  sampleNegatives: "Схожі",
  previewLabel: "Знайдені фрагменти",
  emptyPreview: "Тут з’являться підсвічені фрагменти.",
  maskedLabel: "Маскований текст",
  copy: "Копіювати",
  copied: "Скопійовано",
  copyFailed: "Не вдалося скопіювати",
  paste: "Вставити",
  pasted: "Вставлено",
  pasteFailed: "Не вдалося вставити",
  maskMode: "Режим маски",
  maskModeHint: "Як замінювати знайдені фрагменти в маскованому тексті.",
  maskPlaceholder: "Замінник",
  maskPartial: "Частково",
  maskPseudonym: "Псевдоніми",
  maskPlaceholderHint: "Кожен фрагмент стає [ТИП], наприклад [IBAN].",
  maskPartialHint: "Лишає короткий хвіст значення, решту ховає.",
  maskPseudonymHint: "Стабільні мітки в цьому тексті: RNOKPP_1, PERSON_1…",
  types: "Типи",
  typesHint: "Вимкніть тип, щоб лишити його в маскованому тексті.",
  nerLoadHint: "Один раз завантажує ~110 МБ з Hugging Face і далі працює на цьому пристрої.",
  typesAll: "Усі",
  typesNone: "Жоден",
  entities: "Сутності",
  entityType: "Тип",
  entityValue: "Значення",
  entitySource: "Джерело",
  entitySpan: "Фрагмент",
  sourceRule: "правило",
  sourceModel: "модель",
  noEntities: "Нічого не знайдено.",
  count: "{n} сутностей",
  layerRules: "Лише правила",
  layerHybrid: "Правила + NER",
  nerIdle:
    "Правила вже ловлять IBAN, картки, ІПН, телефони, паспорти, УНЗР і пошту. Щоб знаходити імена, увімкніть українську NER-модель (~110 МБ, один раз, кешується на цьому пристрої).",
  nerLoad: "Увімкнути імена",
  nerLoading: "Завантаження моделі…",
  nerReady: "Модель готова. Імена й локації додаються до правил.",
  nerError: "Модель не завантажилась.",
  nerRetry: "Повторити",
  nerRefreshHint: "Оновіть сторінку з очищенням кешу (Ctrl+Shift+R) і натисніть Повторити. Стара вкладка тримає стару політику безпеки.",
  tooLong: "Текст обрізано до {n} символів, щоб вкладка лишалась живою.",
  limitationsTitle: "Обмеження",
  limitationsBody: "Цей інструмент не є засобом забезпечення юридичної чи нормативної відповідності. Ваги моделі завантажуються безпосередньо з Hugging Face Hub, а введений текст обробляється виключно у вашому браузері.",
  footerBlurb: "Редактор ПІІ в браузері. Без сервера. Текст лишається у вкладці. © 2026",
  footerContact: "Контакт:",
  footerGithub: "GitHub",
  metricsTitle: "Held-out метрики",
  metricsLead:
    "Синтетичний held-out набір, 53 документи, 99 золотих фрагментів. Поріг NER вибрано до цього спліту.",
  metricsLayer: "Шар",
  metricsP: "P",
  metricsR: "R",
  metricsF1: "F1",
  metricsSupport: "N",
  metricsHybrid: "гібрид",
  metricsRules: "правила",
  metricsModel: "модель",
  metricsPerType: "Гібрид за типом",
  metricsNote:
    "PERSON майже повністю з моделі. Контрольні суми (IBAN, картка, РНОКПП, ЄДРПОУ, УНЗР) лишаються на правилах. ADDRESS падає, бо модель додає міста, а золото розмічає вулиці.",
  typePERSON: "Ім’я",
  typePHONE: "Телефон",
  typeIBAN: "IBAN",
  typeCARD: "Картка",
  typeRNOKPP: "РНОКПП",
  typeEDRPOU: "ЄДРПОУ",
  typePASSPORT: "Паспорт",
  typeUNZR: "УНЗР",
  typeEMAIL: "Email",
  typeADDRESS: "Адреса",
  typeDOB: "Дата народження",
} as const;
